import * as Logger from '../libs/wa-logger';
// const $ = require('jquery');
type FadeCallback = ()=>void
export type ImageDetails = {
	imgObj : HTMLImageElement,
	parent: HTMLDivElement,
	otherImages : HTMLCollection,
	src : string,
	width : string,
	height : string,
};

/**
 * fadein the current target in the carousel
 */
async function async_fadeIn(carousel: Carousel	, duration: number, opacity: number)
{
	return new Promise((resolve, reject) => {
		fadeTo(carousel.target_img_el, duration, 10, opacity, () => {
			resolve("Fadein done")
		})
	})
}
/**
 * fadeout the current target and then update the target
 * in the carousel 
*/
async function async_fadeout(carousel: Carousel, duration: number, opacity: number)
{
	return new Promise((resolve, reject) => {
		fadeTo(carousel.target_img_el, duration, 10, opacity, () => {
			resolve("Fadeout done")
		})
	})
}
/*
* an async delay function
*/
async function async_wait(carousel: Carousel, duration: number)
{
	return new Promise((resolve, reject)=>{
		setTimeout(()=>{
			resolve("")
		})
	})
}
async function async_render_carousel(carousel: Carousel)
{
	carousel.setTargetImageTo(this.start_index);
	while(true) {
		await async_fadeIn(carousel, 1, 1)
		await async_wait(carousel, carousel.display_duration_ms)
		carousel.start_index = (1 + carousel.start_index) % carousel.sources_img_details.length;
		Logger.writeln(`async_render: starting start_index: ${carousel.start_index}`);
		carousel.setTargetImageTo(carousel.start_index);
		await async_fadeout(carousel, 1, 1)
	}
}
/*
** This class represents a single image carousel. An instance is configured by passing index
** an options hash
**
**  options{
**      target_selector:   a jquery selector that gives the <div> that wrap
**                          <img> tag that will display the banner images
**      sources_selector;   a jquery selector that gives a single <div>
**                          and all the <img> tags within that <div> hold the url of the source images
**      displaytime: display period as number of millisecs
*/
export class Carousel {
		time_step_ms: number
		start_index: number
		target_img_el: HTMLImageElement
		sources_img_details: ImageDetails[]
		current_image: number
		fade_in_start_opacity: number
		fade_out_final_opacity: number
		fade_duration_ms: number
		display_duration_ms: number
		timeout_interval_obj: any
	constructor(images_details: ImageDetails[], target_image_element: HTMLImageElement) {
		const me = this;
		this.time_step_ms = 10
		this.start_index = 0;
		this.target_img_el = target_image_element;
		this.sources_img_details = images_details;
		this.current_image = 0;
		this.fade_in_start_opacity = 0.0
		this.fade_out_final_opacity = 0.0
		this.fade_duration_ms = 2000
		this.display_duration_ms = 5000
		if (this.sources_img_details.length <= 1) {
			throw new Error('ERROR no source images');
	}

	}
	// this.async_render = async function() {
	// 	this.setTargetImageTo(this.start_index);
	// 	while(true) {
	// 		await async_fadein(carousel)
	// 		await async_wait(carousel.display_duration_ms)
	// 		this.start_index = (1 + this.start_index) % this.sources.length;
	// 		Logger.writeln(`async_render: starting start_index: ${this.start_index}`);
	// 		this.setTargetImageTo(this.start_index);
	// 		await async_fadeout(carousel)
	// 	}
	// }

	render() {
		// console.log(["carousel.render ", this])
		this.setTargetImageTo(this.start_index);
		fadeTo(this.target_img_el, this.fade_duration_ms, this.time_step_ms, 1.0, () => {
			this.start()
		});
	};
	/**
	* Starts the carousel, every 5 seconds call update
	*/
	start() {
		this.timeout_interval_obj = setTimeout(() => {
			this.update();
		}, this.display_duration_ms);
	};

	/**
	* Fades out the current image, when completed determines the next image
	* and fades that image in
	*/
	update() {
		Logger.writeln(`SingleImageCarousel::update current_index: ${this.start_index}`);
		this.fadeOut(() => {
			Logger.writeln(`SingleImageCarousel::fadeOut Done ${this.start_index}`)
			this.fadeIn(() => {
				Logger.writeln(`SingleImageCarousel::fadeIn Done ${this.start_index}`);
				this.timeout_interval_obj = setTimeout(() => {
					this.update();
				}, this.display_duration_ms)
			})
		});
	};
	displayFirstTargetImage() {
		const element = this.target_img_el;
		var idx = this.start_index
		Logger.writeln(`displayFirstTargetImage idx: ${idx} this.start_index : ${this.start_index}`);
		this.sources_img_details[idx].imgObj.style.display = 'block'
		this.sources_img_details[idx].imgObj.style.opacity = '1.0'
		// $(this.sources_img_details[idx].imgObj).css('display:block');
		// $(this.sources_img_details[idx].imgObj).css('opacity', 1.0);
		const y = this.sources_img_details[idx];
		// $(element).attr('src', y.src);
		element.setAttribute('src', y.src)
	}
	/**
	* Sets the current image in the target div to the image with index  idx
	*/
	setTargetImageTo(idx: number) {
		const element = this.target_img_el;
		Logger.writeln(`show_images idx: ${idx} this.start_index : ${this.start_index}`);
		// $(this.sources_img_details[idx].imgObj).css('display:block');
		// $(this.sources_img_details[idx].imgObj).css('opacity', this.fade_in_start_opacity);
		this.sources_img_details[idx].imgObj.style.display = 'block'
		this.sources_img_details[idx].imgObj.style.opacity = `${this.fade_in_start_opacity}`

		const y = this.sources_img_details[idx];
		// $(element).attr('src', y.src);
		element.setAttribute('src', y.src)
	};
	/**
	* Fades out the current carousel image and then calls the callback function
	*/
	fadeOut(fn: FadeCallback) {
		Logger.writeln(`fadeOut starting`)
		fadeTo(this.target_img_el, this.fade_duration_ms, this.time_step_ms, this.fade_out_final_opacity, fn)
	};
	/**
	* Calcs the index of the next image to show,
	* fades out the the current image by calling fadeOut
	* sets the new display image to the updated index
	* finally fades in the new image and calls the callback function
	*/
	fadeIn(fn: FadeCallback) {
		this.start_index = (1 + this.start_index) % this.sources_img_details.length;
		Logger.writeln(`fadeIn: starting start_index: ${this.start_index}`);
		this.setTargetImageTo(this.start_index);
		// this.target.fadeTo(this.fade_duration_ms, 1.0, fn);
		fadeTo(this.target_img_el, this.fade_duration_ms, this.time_step_ms, 1.0, fn)
	};
}
/**
 * Fade an image element from its currentl opacity to the target opacity
 * and do this over a period of duration_ms. When complete call complete_callback
 * @param {*} imageElement 
 * @param number >= 0 <= 1 target_opacity 
 * @param number > 0 duration_ms 
 * @param ():void complete_callback 
 */
function fadeTo(imageElement: HTMLImageElement, duration_ms: number, time_step_ms: number, targetOpacity: number, completeCallback: FadeCallback) {
	const op = imageElement.style.opacity
	let currentOpacity = parseFloat(imageElement.style.opacity)
	if(Number.isNaN(currentOpacity)) {
		currentOpacity = 0
	}
	let isFadeIn = currentOpacity < targetOpacity
	// console.log(["fadeTo: ", imageElement, duration_ms, targetOpacity, currentOpacity, isFadeIn])
	imageElement.style.display = 'block'; // Ensure it's visible to fade in

	let startTime = 0
	function animate() {
		const currentTime = Date.now()
		if(startTime === 0) {
			startTime = currentTime
		}
		const progress = Math.min(1, (currentTime - startTime) / duration_ms)
		const nextOpacity = currentOpacity + (targetOpacity - currentOpacity) * progress
		// console.log(["animate: ", progress, nextOpacity])
		imageElement.style.opacity = `${nextOpacity}`
		if(progress < 1) {
			setTimeout(animate, time_step_ms)
		} else {
			completeCallback()
		}
	}
	setTimeout(animate, time_step_ms)
}
